module.exports = __webpack_public_path__ + "51bab5f3b924a76b15a40cecdc8b567c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/quiz-icons/finish.png
// module id = 3580
// module chunks = 0